import * as React from "react";
import ReactToPrint from "react-to-print";
import InvoiceInfomation from "../pages/InvoiceInfomation";
import PrintIcon from '@mui/icons-material/Print';
import PreviewPrint from "../pages/PreviewPrint";

export const PrintButton = () => {
    const componentRef = React.useRef(null);

    const onBeforeGetContentResolve = React.useRef(null);

    const [loading, setLoading] = React.useState(false);
    const [text, setText] = React.useState("old boring text");

    const handleAfterPrint = React.useCallback(() => {
        console.log("`onAfterPrint` called");
    }, []);

    const handleBeforePrint = React.useCallback(() => {
        console.log("`onBeforePrint` called");
    }, []);

    const handleOnBeforeGetContent = React.useCallback(() => {
        console.log("`onBeforeGetContent` called");
        setLoading(true);
        setText("Loading new text...");

        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;

            setTimeout(() => {
                setLoading(false);
                setText("New, Updated Text!");
                resolve();
            }, 2000);
        });
    }, [setLoading, setText]);

    React.useEffect(() => {
        if (
            text === "New, Updated Text!" &&
            typeof onBeforeGetContentResolve.current === "function"
        ) {
            onBeforeGetContentResolve.current();
        }
    }, [onBeforeGetContentResolve.current, text]);

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <div className="w-full text-right text-[#b3853e] text-sm">
                <button>
                    <PrintIcon />
                </button>
            </div>

        );
    }, []);

    return (
        <div>
            <ReactToPrint
                content={reactToPrintContent}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint
                trigger={reactToPrintTrigger}
                pageStyle={`@media print {
                    @page {
                      size: 80mm 80mm;
                      margin: 5mm
                    },
                    header,footer { 
                        display: none; 
                      }
                  }`}
            />
            <PreviewPrint ref={componentRef} text={text} />
        </div>
    );
};
